<!-- 举报 -->
<template>
    <el-popover
        trigger="manual"
        placement="top"
        width="200"
        v-model="visible"
        style="font-weight: 300">
        <!-- 注意，chunk 是保留字，不要定义为变量了 -->
        <el-row v-for="c in chunkTipoffs" :key="c[0]">
            <el-col :span="12"><el-radio v-model="radio" :label="c[0]" @change="checked">{{c[0]}}</el-radio></el-col>
            <el-col :span="12"><el-radio v-model="radio" :label="c[1]" @change="checked">{{c[1]}}</el-radio></el-col>
        </el-row>
        <div style="margin-top: 4px">
            <el-input ref="input"
                v-model="inputText"
                placeholder="请输入内容"
                size="medium"
                :disabled="inputDisable"
                :maxlength="20"
                :minLength="2"
                @input="inputChange"
                show-word-limit></el-input>
            <!-- 这里使用 visibility 保留空间的高度，如果使用 v-show 的话它是使用的 display:none 当隐藏后不会保留空间高度 -->
            <div class="error" :style="{visibility: visibility_}">{{errorMessage}}</div>
        </div>
        <div style="text-align: right; margin: 6px 22px 0 0">
            <el-button size="medium" type="text" @click="visible = false">取消</el-button>
            <el-button type="danger" size="medium" @click="submit" >确定</el-button>
        </div>
        <div slot="reference" @click="open">
            <slot></slot>
        </div>
    </el-popover>
</template>

<script>
    import _ from 'lodash'
    import { CachedApiSecurity } from "../../api-security";
    import { sendTipoffs } from "../../data/user";
    import { successMessage, errorMessage } from "../../utils";

    export default {
        name: "Tipoff",
        props: {
            type: String, // 取值 entity 或者 thread.
            id: String
        },
        data() {
            return {
                visible: false,
                radio: null,
                inputDisable: true,
                inputText: '',
                showError: false,
                errorMessage: ''
            };
        },
        computed: {
            chunkTipoffs() {
                return _.chunk(this.$store.state.tipoffs, 2);
            },
            visibility_ () {
                return this.showError ? 'initial': 'hidden';
            }
        },
        methods: {
            open(){
                console.log('Tipoff, try to open');
                if (!CachedApiSecurity.isSignedIn())
                    CachedApiSecurity.handleNoAuthorith();
                else{
                    this.visible = true;
                }
            },
            checked(val) {
                console.log('Tipoff, radio checked, the val is', val);
                if(val === '其它'){
                    this.inputDisable = false;
                    this.$nextTick(()=>{
                        this.$refs.input.focus();  // 要在 next tick 中才能生效。
                    })
                }else{
                    this.inputDisable = true;
                }
            },
            inputChange(){
                this.showError = false;
            },
            async submit() {
                try{
                    console.log(`try to submit {_id: ${this.id}, type: ${this.type}, tipoffCode: ${this.radio}`)
                    let tipoffCode = this.radio;
                    if (this.radio === '其它' ){
                        this.__validateInput();
                        await sendTipoffs(this.id, this.type, tipoffCode, this.inputText);
                    }else {
                        await sendTipoffs(this.id, this.type, tipoffCode);
                    }
                    successMessage('提交成功！');
                    this.showError = false;
                    setTimeout(()=>{
                        this.visible = false;
                    }, 300)
                } catch(error){
                    console.error(error);
                    errorMessage('提交失败，清稍后再试');
                }
            },

            /**
             *
             * @return {boolean} true if validate pass
             * @private
             */
            __validateInput(){
                if (this.inputText === ''){
                    this.errorMessage = '原因不能为空';
                    this.showError = true;
                    return false;
                }else if (this.inputText.length < 2){
                    this.errorMessage = '至少必须输入两个字符';
                    this.showError = true;
                    return false;
                }else if (this.inputText.length > 20){
                    this.errorMessage = '最多不能超过 20 个字符';
                    this.showError = true;
                    return false;
                }
                this.showError = false;
                return true;
            }
        }

    }
</script>

<style scoped>
    /deep/ .el-radio{
        font-size: 14px !important;
        font-weight: 400 !important;
        margin: 0 !important;
        padding: 5px 20px 5px 0 !important;
    }

    /deep/ .el-radio__label{
        padding-left: 5px;
    }

    .el-row {
        margin-bottom: 8px;
    }

    .error{
        padding: 4px 4px 4px 14px;
        color: #CB0101;
        min-height: 22px;
        height: 22px;
        line-height: 22px;
    }
</style>



// WEBPACK FOOTER //
// src/components/commons/Tipoff.vue